export default "__VITE_ASSET__67c12989__"